import PropTypes from "prop-types";
import GoogleAutoCompleteField from "../../../../../globals/components/forms/GoogleAutoCompleteField";

const GoogleAutoComplete = (props) => (
  <GoogleAutoCompleteField
    includeCounty
    clearOnSelect
    searchIconPosition="end"
    {...props}
  />
);

GoogleAutoComplete.propTypes = {
  callback: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  label: PropTypes.string,
};

export default GoogleAutoComplete;
